import React from 'react'
import AppRouter from '../AppRouter'
const index = () => {
  return (
    <div className=''>
     <AppRouter />
    </div>
  )
}

export default index
